import { render, staticRenderFns } from "./Mypage.vue?vue&type=template&id=2786b6b2&scoped=true&"
import script from "./Mypage.vue?vue&type=script&lang=js&"
export * from "./Mypage.vue?vue&type=script&lang=js&"
import style0 from "./Mypage.vue?vue&type=style&index=0&id=2786b6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786b6b2",
  null
  
)

export default component.exports